// src/config/firebase.ts - Firebase SDK setup para compatibilidad de tipos con componentes legacy
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyD43uNhtAKMTEbjPtQBId67MnrKL81axXg",
  authDomain: "sisgimnasio.firebaseapp.com",
  projectId: "sisgimnasio",
  storageBucket: "sisgimnasio.firebasestorage.app",
  messagingSenderId: "434544305726",
  appId: "1:434544305726:web:676b935206eb174ecf136f"
};

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = {} as any;
export const secondaryAuth = auth;

export default app;